import React, { useEffect, useState } from "react";
import { fetchDashboard } from "@/lib/api";
import { getFavorites } from "@/lib/storage";
import { StationCard } from "@/components/StationCard";
import { Mascot } from "@/components/Mascot";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export default function FavoritesPage() {
  const [data, setData] = useState(null);
  const [favs, setFavs] = useState(getFavorites());

  useEffect(() => {
    fetchDashboard().then(setData).catch(() => {});
    const onF = (e) => setFavs(e.detail || []);
    window.addEventListener("creep:favorites", onF);
    return () => window.removeEventListener("creep:favorites", onF);
  }, []);

  const favStations = data?.stations?.filter((s) => favs.includes(s.station.id)) || [];

  return (
    <div data-testid="favorites-page">
      <header className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.35em] text-violet-300/80 mb-2">Favoritos</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">
          Tus estaciones {" "}
          <span
            style={{
              background: "linear-gradient(180deg, #C4B5FD 0%, #7C3AED 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            veneradas
          </span>
        </h1>
        <p className="text-white/60 text-sm mt-2 max-w-2xl">
          Se guardan localmente en tu dispositivo. Sin registros, sin fricciones.
        </p>
      </header>

      {favStations.length === 0 ? (
        <div className="creep-glass p-10 text-center" data-testid="favorites-empty">
          <Mascot variant="wave" size={140} />
          <div className="mt-4 text-white/80 font-semibold text-lg">
            Aún no hay estaciones favoritas
          </div>
          <div className="text-white/50 text-sm">
            Pulsa la <Star className="inline" size={12} /> estrella en cualquier tarjeta para invocar tu top personal.
          </div>
          <Link to="/" data-testid="favorites-explore" className="creep-btn mt-6 inline-block">
            Explorar estaciones
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="favorites-grid">
          {favStations.map((s) => (
            <StationCard key={s.station.id} data={s} />
          ))}
        </div>
      )}
    </div>
  );
}
